import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';

import { optionalAttribute } from 'utils/jsx';

import styles from './PurchaserRating.css';

const cx = classNames.bind(styles);
const maxRating = 5;

const calcRatingWidth = function(avgRating) {
  return `${Math.ceil(avgRating / maxRating * 10) * 10 + 1.5}%`;
};

const renderTotalCount = (totalCount, asterisk, parenthesis, plusKey, showReview, reviewContent, shouldRender = true) => {
  let countText = totalCount.toLocaleString();

  if (!shouldRender) {
    return null;
  }

  if (parenthesis) {
    countText = `(${totalCount.toLocaleString()})`;
  }

  if (plusKey) {
    countText = `${totalCount.toLocaleString()}+`;
  }

  if (parenthesis && asterisk) {
    countText = `(${totalCount.toLocaleString()})*`;
  }

  if (parenthesis && plusKey) {
    countText = `(${totalCount.toLocaleString()}+)`;
  }

  if (showReview) {
    countText += ` ${reviewContent}`;
  }

  return <span className={styles[`row-spacing`]}>{countText}</span>;
};

const renderAverageRating = (avgRating, displayType, shouldRender) => {
  if (!shouldRender) {
    return null;
  }

  const averageClass = optionalAttribute(`className`, styles[`row-spacing`], displayType === `row`);

  return <span {...averageClass}>{avgRating.toFixed(1)}/{maxRating}</span>;
};

const PurchaserRating = (props) => {
  const containerClass = cx(`container`, {
    'container--column': props.displayType === `column`,
    'container--row': props.displayType === `row`,
    [props.containerStyles]: props.containerStyles,
  });
  const starsBackgroundClass = cx(`stars-background`, {
    'stars-background--large': props.largeIcon,
    [props.starsBackgroundStyles]: props.starsBackgroundStyles,
  });
  const starsFillClass = cx(`stars-fill`, {
    'stars-fill--large': props.largeIcon,
    [props.starsFillStyles]: props.starsFillStyles,
  });
  const averageCountClass = cx(`count-container`, {
    'hide-mobile': props.hideCountMobile,
    [props.countStyles]: props.countStyles,
  });

  optionalAttribute(`className`, styles[`hide-mobile`], props.hideCountMobile);

  return (
    <div className={containerClass}>
      <abbr className={starsBackgroundClass}>
        <span
          className={starsFillClass}
          style={{width: calcRatingWidth(props.avgRating)}}
        />
      </abbr>
      <span className={averageCountClass}>
        {renderAverageRating(props.avgRating, props.displayType, props.showAverage)}
        {renderTotalCount(props.totalCount, props.asterisk, props.parenthesis, props.plusKey, props.showReviews, props.reviewContent, props.showTotalCount)}
      </span>
    </div>
  );
};

PurchaserRating.propTypes = {
  asterisk: PropTypes.bool,
  avgRating: PropTypes.number.isRequired,
  containerStyles: PropTypes.string,
  countStyles: PropTypes.string,
  displayType: PropTypes.oneOf([ `column`, `row` ]),
  hideCountMobile: PropTypes.bool,
  largeIcon: PropTypes.bool,
  parenthesis: PropTypes.bool,
  plusKey: PropTypes.bool,
  reviewContent: PropTypes.string,
  showAverage: PropTypes.bool,
  showReviews: PropTypes.bool,
  showTotalCount: PropTypes.bool,
  starsBackgroundStyles: PropTypes.string,
  starsFillStyles: PropTypes.string,
  totalCount: PropTypes.number.isRequired,
};

PurchaserRating.defaultProps = {
  asterisk: false,
  displayType: `row`,
  hideCountMobile: false,
  parenthesis: false,
  plusKey: false,
  showAverage: true,
  showReviews: false,
  showTotalCount: true,
};

export default PurchaserRating;
